module.exports = __webpack_public_path__ + "img/Windy.f68c9f5e.jpg";